var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      attrs: { name: "loginform" },
      on: {
        submit: function($event) {
          $event.preventDefault()
          _vm.loginUser(_vm.login)
        }
      }
    },
    [
      _c("h1", { staticClass: "modal__container--title" }, [
        _vm._v("Sign in to your account")
      ]),
      _c("div", { staticClass: "modal__product--divider" }),
      _c("div", { staticClass: "ui-input" }, [
        _c("p", [_vm._v("Username or Email")]),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.login.username,
              expression: "login.username"
            }
          ],
          attrs: {
            type: "text",
            name: "username",
            placeholder: "Your username or email",
            required: "required"
          },
          domProps: { value: _vm.login.username },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.login, "username", $event.target.value)
            }
          }
        })
      ]),
      _c("div", { staticClass: "ui-input" }, [
        _c("p", [_vm._v("Password")]),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.login.password,
              expression: "login.password"
            }
          ],
          attrs: {
            type: "password",
            name: "password",
            placeholder: "Your password",
            required: "required"
          },
          domProps: { value: _vm.login.password },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.login, "password", $event.target.value)
            }
          }
        })
      ]),
      _c("div", { staticClass: "modal__product--divider divider--bottom" }),
      _c(
        "button",
        { staticClass: "btn btn--purpleLight", attrs: { type: "submit" } },
        [_vm._v("Sign In")]
      ),
      _c("div", { staticClass: "options" }, [
        _c("p", [
          _c(
            "a",
            {
              staticClass: "link",
              on: {
                click: function($event) {
                  _vm.showRegistration()
                }
              }
            },
            [_vm._v("Don't have an account?")]
          )
        ]),
        _c("p", [
          _c(
            "a",
            {
              staticClass: "link",
              on: {
                click: function($event) {
                  _vm.showForgetPass()
                }
              }
            },
            [_vm._v("Forgot password?")]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0d721702", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d721702","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/buyModalLogin.vue
// module id = null
// module chunks = 